// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"


// stimulus autocomplete (installed as yarn package)
import { Autocomplete } from 'stimulus-autocomplete'
application.register('autocomplete', Autocomplete)

// stimulus searchable (installed as yarn package)
// import Sortable without {} to avoid confliction Chart.js on Home Screen
import Sortable from 'stimulus-sortable'
application.register('sortable', Sortable)

//
// local controller
//

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MyBootstrapController from "./my_bootstrap_controller"
application.register("my_bootstrap", MyBootstrapController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import AutoRefreshController from "./auto_refresh_controller"
application.register("auto-refresh", AutoRefreshController)

import BulkSelectionController from "./bulk_selection_controller"
application.register("bulk-selection", BulkSelectionController)

import DeliveryDateSyncController from "./delivery_date_sync_controller"
application.register("delivery-date-sync", DeliveryDateSyncController)

import SimpleOrderItemsController from "./simple_order_items_controller"
application.register("simple-order-items", SimpleOrderItemsController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import TranslationController from "./translation_controller"
application.register("translation", TranslationController)

import ProcurementSelectionController from "./procurement_selection_controller"
application.register("procurement-selection", ProcurementSelectionController)

import AssemblyTreeController from "./assembly_tree_controller"
application.register("assembly-tree", AssemblyTreeController)
